import { render, staticRenderFns } from "./NewApplication.vue?vue&type=template&id=0138f75c&scoped=true"
import script from "./NewApplication.vue?vue&type=script&lang=js"
export * from "./NewApplication.vue?vue&type=script&lang=js"
import style0 from "./NewApplication.vue?vue&type=style&index=0&id=0138f75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138f75c",
  null
  
)

export default component.exports